import * as tslib_1 from "tslib";
import CreateStaffSelector from "../../../../../form/src/common/components/createStaffSelector.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
let StaffMultiSelectorDesign = class StaffMultiSelectorDesign extends Vue {
    render(h) {
        return h('create-staff-selector', { props: { opts: { disabled: true }
            } });
    }
};
tslib_1.__decorate([
    Prop()
], StaffMultiSelectorDesign.prototype, "control", void 0);
StaffMultiSelectorDesign = tslib_1.__decorate([
    Component({
        name: 'StaffMultiSelectorDesign',
        components: {
            CreateStaffSelector
        }
    })
], StaffMultiSelectorDesign);
export default StaffMultiSelectorDesign;
